import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"src/app/[lang]/contact-us/layout.tsx\",\"import\":\"Noto_Sans\",\"arguments\":[{\"subsets\":[\"cyrillic\",\"cyrillic-ext\",\"devanagari\",\"greek\",\"greek-ext\",\"latin\",\"latin-ext\",\"vietnamese\"],\"variable\":\"--font-family-var\",\"display\":\"swap\"}],\"variableName\":\"sen\"}");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/components/CookieBanner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/components/CurrencySelector.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/components/FooterNav.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/components/LanguageAndCurrencyMobile/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/styles/globals.css");
